(function () {
	const initProductAccordion = () => {
		$(".about__accordion-toggle").click(function () {
			if (!$(this).hasClass("active")) {
				$(this).addClass("active");
				$(this)
					.siblings(".about__accordion-description")
					.eq($(this).index())
					.stop()
					.slideDown(300);
			} else {
				$(this).removeClass("active");
				$(this).siblings(".about__accordion-description").stop().slideUp(300);
			}
		});
	};

	const initZoomImage = () => {
		const imagesWrapper = document.querySelector(
			".product-media-modal__content"
		);
		const images = imagesWrapper.querySelectorAll(".js-image-zoom");

		images.forEach((el) => {
			el.addEventListener("click", (e) => {
				imagesWrapper.classList.toggle("zoom");
			});
		});
	};



	const revealPopup = () => {
		const stickyBar = document.querySelector('.product__popup'); // Sticky bar
		const secondSection = document.querySelector('.product-section + section'); // Second section
		const footer = document.querySelector('footer'); // Footer

		// Check if the required elements exist
		if (!stickyBar || !secondSection || !footer) {
				console.error('Required elements not found!');
				return;
		}

			const getOffset = (element) => {
				const rect = element.getBoundingClientRect();
				return rect.top + window.scrollY;
			};

			const secondSectionMid = getOffset(secondSection);
			const footerTop = getOffset(footer);

			const handleScroll = () => {
				const scrollPosition = window.scrollY + window.innerHeight;
				const activeOffset = window.scrollY > secondSectionMid && scrollPosition < footerTop;

				stickyBar.classList[activeOffset ? "add" : "remove"]('active');
			};

			// Initial check in case the user starts in the middle of the page
			handleScroll();
};

	document.addEventListener('scroll', () => revealPopup());


	document.addEventListener("shopify:section:load", function () {
		initProductAccordion();
		initZoomImage();
		revealPopup();
	});

	initProductAccordion();
	initZoomImage();
	revealPopup();
})();

class FloatedForm extends HTMLElement {
	constructor() {
		super();
		this.renderForm();
	}

	renderForm() {
		fetch(this.getAttribute("data-product-url"))
			.then((response) => response.text())
			.then((responseText) => {
				const responseHTML = new DOMParser().parseFromString(
					responseText,
					"text/html"
				);
				this.productElement = responseHTML.querySelector(
					'div[id^="ProductInfo-"]'
				);

				this.preventDuplicatedIDs();
				this.removeDOMElements();
				this.setInnerHTML(this, this.productElement.innerHTML);

				if (window.Shopify && Shopify.PaymentButton) {
					Shopify.PaymentButton.init();
				}

				if (window.ProductModel) window.ProductModel.loadShopifyXR();

				this.showMoreFields();
			})
			.finally(() => {
				const selectDropDown = () => {
					$(".product__popup .product-form__controls--dropdown").each(function () {
						const elListItem = $(this).find(".dropdown-select ul li");
						const elItem = $(this).find(".dropdown-select ul");
						const selectedText = $(this).find(
							".dropdown-select .select-label"
						);

						selectedText.on("click", function (e) {
							elItem.toggleClass("active");
							if (elItem.hasClass("active")) {
								e.stopPropagation();
								$(document).click(function () {
									elItem.removeClass("active");
								});
							}
						});

						elListItem.on("click", function () {
							selectedText
								.find("span")
								.text($(this).text())
								.attr("title", $(this).text());
							elItem.removeClass("active");
							document.activeElement.blur();
						});
					});
				};

				selectDropDown();
			});
	}

	setInnerHTML(element, html) {
		element.innerHTML = html;

		// Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
		element.querySelectorAll("script").forEach((oldScriptTag) => {
			const newScriptTag = document.createElement("script");
			Array.from(oldScriptTag.attributes).forEach((attribute) => {
				newScriptTag.setAttribute(attribute.name, attribute.value);
			});
			newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
			oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
		});
	}

	preventDuplicatedIDs() {
		const sectionId = this.productElement.dataset.section;
		this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(
			sectionId,
			`floated-${sectionId}`
		);

		if (this.productElement.querySelectorAll("variant-selects")) {
			this.productElement
				.querySelectorAll("variant-selects")
				.forEach((radio) => {
					radio.dataset.originalSection = sectionId;
				});
		}

		if (this.productElement.querySelectorAll("variant-radios")) {
			this.productElement
				.querySelectorAll("variant-radios")
				.forEach((radio) => {
					radio.dataset.originalSection = sectionId;
				});
		}
	}

	removeDOMElements() {
		const text = this.productElement.querySelector(".product__text");
		if (text) text.remove();

		const tags = this.productElement.querySelector(".product__tags");
		if (tags) tags.remove();

    const title = this.productElement.querySelector(".product__title__wrapper");
		if (title) title.remove();

		const badges = this.productElement.querySelector(".product__custom-badges");
		if (badges) badges.remove();

    const price = this.productElement.querySelector(".price-wrapper");
		if (price) price.remove();

		const description = this.productElement.querySelector(
			".product__description"
		);
		if (description) description.remove();

		const sku = this.productElement.querySelector(".product__sku");
		if (sku) sku.remove();

		const inventory = this.productElement.querySelector(".product__inventory");
		if (inventory) inventory.remove();

		const pickupAvailability = this.productElement.querySelector(
			"pickup-availability"
		);
		if (pickupAvailability) pickupAvailability.remove();

		const customLiquid = this.productElement.querySelector(".custom-liquid");
		if (customLiquid) customLiquid.remove();

		const complementary = this.productElement.querySelector(
			"product-recommendations"
		);
		if (complementary) complementary.remove();

		const shareButtons = this.productElement.querySelector(".share-buttons");
		if (shareButtons) shareButtons.remove();

		const trustpilotBlocks = this.productElement.querySelectorAll(
			".product__trustpilot-under-title, .product__trustpilot-above-payment"
		);
		trustpilotBlocks.forEach((el) => {
			el.remove();
		});

		const productModal = this.productElement.querySelectorAll(".product-popup");
		productModal.forEach((advantage) => {
			advantage.remove();
		});

		const productForm = this.productElement.querySelector("floated-form");
		if (productForm) productForm.remove();
	}

	showMoreFields() {
		$(".js-show-more").click(function (e) {
			e.preventDefault();
			$(this).siblings("input").removeClass("hidden");
			$(this).siblings("label").removeClass("hidden");
			$(this).remove();
		});
	}
}

customElements.define("floated-form", FloatedForm);


document.querySelectorAll('.collapsible-content__answer-inner').forEach(inner => {
  const segments = inner.innerHTML.split(/<br\s*\/?>/i);
  const kept = segments.filter(seg => {
    const idx = seg.indexOf(':');
    if (idx === -1) return true;
    const after = seg
      .slice(idx + 1)
      .replace(/<[^>]*>/g, '')
      .replace(/&nbsp;/gi, '')
      .trim();
    return after.length > 0;
  });

  inner.innerHTML = kept.join('<br>');
  const text = inner.textContent.replace(/\u00a0/g, '').trim();
  if (text.length === 0) {
    const item = inner.closest('.collapsible-content__item');
    if (item) item.style.display = 'none';
  }
});


(function () {
  'use strict';

  // ---- Config -------------------------------------------------------------
  var SELECTOR       = '.product__description'; // the description block element
  var MAX_LINES      = 5;
  var READ_MORE_TEXT = 'Read more';
  var READ_LESS_TEXT = 'Read less';
  var ANIM_MS        = 350;

  // ---- Inject styles once -------------------------------------------------
  var STYLE_ID = 'rm-readmore-styles';
  if (!document.getElementById(STYLE_ID)) {
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent =
      SELECTOR + '.rm-collapsible{overflow:hidden;transition:max-height ' + ANIM_MS + 'ms ease;}' +
      '.rm-toggle{display:inline-flex;align-items:center;margin-top:.6em;padding:0;background:none;' +
        'border:0;cursor:pointer;font:inherit;font-size:.9em;font-weight:600;color:currentColor;' +
        'text-decoration:underline;text-underline-offset:2px;}' +
      '.rm-toggle:hover{opacity:.7;}';
    document.head.appendChild(style);
  }

  function init(el) {
    var cs        = getComputedStyle(el);
    var lineH     = parseFloat(cs.lineHeight) || parseFloat(cs.fontSize) * 1.4;
    var padding   = (parseFloat(cs.paddingTop) || 0) + (parseFloat(cs.paddingBottom) || 0);
    var collapsedH = Math.round(lineH * MAX_LINES + padding);
    var btn        = el._rmBtn;
    var needsToggle = el.scrollHeight > collapsedH + 2; // scrollHeight = full height, ignores clamp

    // Doesn't overflow (or not laid out yet, e.g. hidden breakpoint): clean up.
    if (!needsToggle) {
      if (btn) { btn.remove(); el._rmBtn = null; }
      el.classList.remove('rm-collapsible');
      el.style.maxHeight = '';
      el._rmExpanded = false;
      return;
    }

    // Build the toggle button the first time.
    if (!btn) {
      btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'rm-toggle';
      btn.setAttribute('aria-expanded', 'false');
      btn.textContent = READ_MORE_TEXT;
      el.insertAdjacentElement('afterend', btn);
      el._rmBtn = btn;
      el._rmExpanded = false;

      btn.addEventListener('click', function () {
        if (el._rmExpanded) {
          // Collapse: lock current height, force reflow, animate down.
          el.style.maxHeight = el.scrollHeight + 'px';
          void el.offsetHeight;
          el.style.maxHeight = collapsedH + 'px';
          btn.textContent = READ_MORE_TEXT;
          btn.setAttribute('aria-expanded', 'false');
          el._rmExpanded = false;
        } else {
          // Expand: animate to full height, then release the clamp so dynamic
          // content (e.g. theme-editor edits) isn't capped.
          el.style.maxHeight = el.scrollHeight + 'px';
          btn.textContent = READ_LESS_TEXT;
          btn.setAttribute('aria-expanded', 'true');
          el._rmExpanded = true;
          el.addEventListener('transitionend', function done(e) {
            if (e.target !== el || e.propertyName !== 'max-height') return;
            if (el._rmExpanded) el.style.maxHeight = 'none';
            el.removeEventListener('transitionend', done);
          });
        }
      });
    }

    el.classList.add('rm-collapsible');
    if (!el._rmExpanded) el.style.maxHeight = collapsedH + 'px';
  }

  function initAll() {
    document.querySelectorAll(SELECTOR).forEach(init);
  }

  // ---- Boot ---------------------------------------------------------------
  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);

  document.addEventListener('shopify:section:load', initAll); // theme editor

  var t; // re-evaluate on resize (re-wrapping / mobile↔desktop breakpoint swaps)
  window.addEventListener('resize', function () {
    clearTimeout(t);
    t = setTimeout(initAll, 200);
  });
})();
